/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AvailableForAllocationReinsuredOptionDto
 */
export interface AvailableForAllocationReinsuredOptionDto {
    /**
     * 
     * @type {string}
     * @memberof AvailableForAllocationReinsuredOptionDto
     */
    reinsuredId: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableForAllocationReinsuredOptionDto
     */
    name: string;
}

/**
 * Check if a given object implements the AvailableForAllocationReinsuredOptionDto interface.
 */
export function instanceOfAvailableForAllocationReinsuredOptionDto(value: object): value is AvailableForAllocationReinsuredOptionDto {
    if (!('reinsuredId' in value) || value['reinsuredId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AvailableForAllocationReinsuredOptionDtoFromJSON(json: any): AvailableForAllocationReinsuredOptionDto {
    return AvailableForAllocationReinsuredOptionDtoFromJSONTyped(json, false);
}

export function AvailableForAllocationReinsuredOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableForAllocationReinsuredOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'reinsuredId': json['reinsuredId'],
        'name': json['name'],
    };
}

export function AvailableForAllocationReinsuredOptionDtoToJSON(json: any): AvailableForAllocationReinsuredOptionDto {
    return AvailableForAllocationReinsuredOptionDtoToJSONTyped(json, false);
}

export function AvailableForAllocationReinsuredOptionDtoToJSONTyped(value?: AvailableForAllocationReinsuredOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reinsuredId': value['reinsuredId'],
        'name': value['name'],
    };
}

